import { graphql } from "src/gql"
import { graphqlClient } from "@myvp/shared/src/functions/request"

export const listSiteMetrics = async (globalSponsorStudyId: string) => {
  const query = graphql(/* GraphQL */ `
    query listSiteMetrics($input: ListSiteMetricsInput!) {
      listSiteMetrics(input: $input) {
        siteSummaryMetrics {
          siteId
          siteNumber
          country
          siteName
          siteStatus
          versionStatus
          version
          countParticipants
          eproCompliance
          eclinroCompliance
          hasEpro
          hasEclinro
        }
      }
    }
  `)
  const result = await graphqlClient.request(query, {
    input: {
      globalSponsorStudyId,
    },
  })
  return result.listSiteMetrics
}

export const getSiteAndParticipantMetrics = async (args: {
  globalSponsorStudyId: string
  siteId: string
}) => {
  const query = graphql(/* GraphQL */ `
    query getSiteAndParticipantMetrics(
      $input: GetSiteAndParticipantMetricsInput!
    ) {
      getSiteAndParticipantMetrics(input: $input) {
        generatedAt
        siteParticipantMetrics {
          siteSummaryMetrics {
            completedSurveys
            countParticipants
            countSupportedLanguages
            eclinroCompliance
            eproCompliance
            hasEclinro
            hasEpro
            siteNumber
            supportedLanguages
            version
            versionStatus
            countAvailableEclinroSurveys
            countAvailableEproSurveys
            countParticipantsWithSignaturesComplete
            countParticipantsWithSignaturesRequired
            percentCompletedSignaturesByDataSource {
              dataSource
              percentage
            }
          }
          eproParticipantMetrics {
            participantId
            participantNumber
            completedSurveys
            totalSurveys
            completedSurveysPercent
            totalAvailableSurveys
            countAvailableLessThanWeek
            countAvailableMoreThanWeek
          }
          eclinroParticipantMetrics {
            participantId
            participantNumber
            completedSurveys
            totalSurveys
            completedSurveysPercent
            totalAvailableSurveys
            countAvailableLessThanWeek
            countAvailableMoreThanWeek
          }
          participantSignatureMetrics {
            studyParticipantId
            participantNumber
            signatureMetricsByDataSource {
              dataSource
              percentSurveysSigned
              countSurveysSigned
              countSurveysRequiringSignature
            }
          }
        }
      }
      getComplianceSettings {
        threshold
      }
    }
  `)
  const result = await graphqlClient.request(query, {
    input: {
      globalSponsorStudyId: args.globalSponsorStudyId,
      siteId: args.siteId,
    },
  })
  return {
    ...result.getSiteAndParticipantMetrics,
    settings: result.getComplianceSettings,
  }
}
